export const CLOSE_SIDE_BAR = 'CLOSE_SIDE_BAR';
export const SET_ACTIVE_QUESTION_AND_ANSWER = 'SET_ACTIVE_QUESTION_AND_ANSWER';
export const SET_ACTIVE_SIDE_BAR = 'SET_ACTIVE_SIDE_BAR';
